export default __webpack_public_path__ + "static/media/100W_DD_-_Colored_on_Light_Grey_(1).0b74c49d.jpg";